module.exports = __webpack_public_path__ + "static/media/cq_contrassegna_elemento1 b.7d6c3b19.svg";